import Vue from "vue";
Vue.filter("ultimaObrigacao", (obrigacoes) => {
  return obrigacoes.length ? obrigacoes[0].descricao : "Não informado";
});
